import React from "react";
import "./FooterBlog.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent";
import { FaInstagram, FaLinkedin, FaFacebook } from "react-icons/fa";

const FooterBlog = ({ irParaAba }) => {
  return (
    <footer className="footerblog">
      <div className="footerblog-top">
        {/* Coluna 1 - Logo e site */}
        <div className="footerblog-column footerblog-column-logo">
          <img src={Imagens.Logo} alt="Logo Eliandro" className="footerblog-logo" />
          <a
            href="https://www.eliandroalimentos.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="footerblog-site-link"
          >
            www.eliandroalimentos.com.br
          </a>
        </div>

        {/* Coluna 2 - Categorias */}
        <div className="footerblog-column">
          <h4>CATEGORIAS</h4>
          <ul className="footerblog-links">
            <li><button onClick={() => irParaAba("HOME")}>Home</button></li>
            <li><button onClick={() => irParaAba("RECEITAS")}>Receitas</button></li>
            <li><button onClick={() => irParaAba("GUIAS")}>Guias</button></li>
            <li><button onClick={() => irParaAba("DICAS")}>Dicas</button></li>
            <li><button onClick={() => irParaAba("CORTES DE CARNE")}>Cortes de Carne</button></li>
          </ul>
        </div>

        {/* Coluna 3 - Botão */}
        <div className="footerblog-column">
          <button className="footerblog-btn">Conheça nosso site</button>
        </div>

        {/* Coluna 4 - Redes sociais */}
        <div className="footerblog-column footerblog-social-column">
          <a href="https://www.instagram.com/eliandroalimentos" target="_blank" rel="noopener noreferrer"><FaInstagram /> Instagram</a>
          <a href="https://www.facebook.com/eliandroalimentosrs/?locale=pt_BR" target="_blank" rel="noopener noreferrer"><FaFacebook /> Facebook</a>
          <a href="https://br.linkedin.com/company/eliandro-alimentos" target="_blank" rel="noopener noreferrer"><FaLinkedin /> LinkedIn</a>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footerblog-bottom-container">
        <div className="footerblog-bottom">
          <p>
            © {new Date().getFullYear()} Eliandro Alimentos. Todos os direitos reservados.
          </p>
          <p className="footerblog-dev-credit">
            Desenvolvido por{" "}
            <a
              href="https://github.com/ChristpherFeilstrecker"
              target="_blank"
              rel="noopener noreferrer"
            >
              @CFS
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterBlog;
